import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--busy-trigger"
//
// The Site Invoicing tab's trash (CONEK-8263): React swaps the trash icon for a
// spinner and disables the button while it re-reads the account to decide what
// to remove. The Hotwire trash is a Turbo Stream GET, so this marks the link
// busy on click (the icon swap is CSS off `data-busy`) and clears it when the
// answer — any Turbo Stream — arrives, or the request fails.
export default class extends Controller {
  start(event) {
    if (this.element.dataset.busy === "true") {
      event.preventDefault()
      return
    }
    this.element.dataset.busy = "true"
    this.element.setAttribute("aria-disabled", "true")
  }

  stop() {
    delete this.element.dataset.busy
    this.element.removeAttribute("aria-disabled")
  }
}
